import React, { useState } from "react";
import "../../../styles/components/Slices/featureLewitt.scss";
import useWindowWidth from "../../../hooks/useBetterMediaQuery";
import { useMediaQuery } from "react-responsive";

const FeatureLewitt = ({ slice, location }) => {
  const topSpacing = slice?.primary?.top_spacing;
  const bottomSpacing = slice?.primary?.bottom_spacing;
  const oneGrid = slice?.primary?.grid_layout === "1x Card Grid";
  const twoGrid = slice?.primary?.grid_layout === "2x Card Grid";
  const threeGrid = slice?.primary?.grid_layout === "3x Card Grid";
  const fourGrid = slice?.primary?.grid_layout === "4x Card Grid";
  const fiveGrid = slice?.primary?.grid_layout === "5x Card Grid";
  const fivePlusGrid = slice?.primary?.grid_layout === "5+ Card Grid";
  const isDesktop = useWindowWidth(1023);
  const isTablet = useMediaQuery({ minWidth: 640, maxWidth: 1023 });
  const isMobile = useMediaQuery({ maxWidth: 639 });
  const [hoverIndex, setHoverIndex] = useState(null);

  return (
    <section className="relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl">
      <article
        className={`relative lg:mx-11 ${topSpacing === "80" && "sm:mt-20 mt-8"} ${topSpacing === "40" && "sm:mt-10 mt-8"} ${topSpacing === "0" && "mt-0"} ${bottomSpacing === "80" && "sm:mb-20 mb-8"} ${bottomSpacing === "40" && "sm:mb-10 mb-8 "} ${bottomSpacing === "0" && "mb-0"}`}
      >
        <div
          className={`${twoGrid && "flex gap-5 flex-col lg:flex-row"} ${threeGrid && "grid gap-5 grid-col-1 lg:grid-cols-12 "} ${fourGrid && "grid grid-cols-1 sm:grid-cols-2 gap-4"} ${fiveGrid && "grid gap-5 grid-col-1 lg:grid-cols-12"} ${fivePlusGrid && "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12  lg:grid-rows-3 gap-4"}`}
        >
          {/* One Grid and Two Grid Layout */}
          {((oneGrid && slice?.items?.length === 1) ||
            (twoGrid && slice?.items?.length === 2)) &&
            slice?.items.map((card, index) => {
              return (
                <a
                  href={card?.link?.url}
                  target="_blank"
                  className={`${twoGrid && "w-full"}`}
                >
                  <div
                    className={`rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative `}
                    style={{
                      backgroundImage: `url(${card?.card_image?.url || ""})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      objectFit: "fill",
                      backgroundPosition: "center",
                    }}
                    onMouseEnter={() => setHoverIndex(index)}
                    onMouseLeave={() => setHoverIndex(null)}
                  >
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear`}
                    />
                    {/* Hover gradient (fades in on hover) */}
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                        hoverIndex === index
                          ? "opacity-100 duration-500 delay-0"
                          : "opacity-0 duration-300 delay-0"
                      }`}
                    />
                    <div className="flex flex-col justify-between h-full gap-[145px] sm:gap-[405px] lg:gap-[411px] ">
                      <img
                        className="max-w-28 sm:h-full sm:max-h-full sm:max-w-48 z-10"
                        alt={card?.logo?.alt || "Card_logo"}
                        loading="eager"
                        src={card?.logo?.url}
                      />
                      <div className="z-10 relative">
                        <p
                          className={`text-white font-manrope text-5.5xl sm:text-[90px] font-semibold leading-[68px] sm:leading-[100px] -tracking-[3px] sm:-tracking-[4.5px] transition-opacity ${hoverIndex === index ? "opacity-0 duration-300 delay-0" : "opacity-100  duration-500 delay-300"}`}
                        >
                          {card?.stat_headline?.text}
                        </p>
                        {card?.stat_descriptor?.text && (
                          <p
                            className={`text-white font-manrope text-xl font-semibold sm:text-2xl transition-opacity tracking-tighter_2 sm:tracking-tightest_5 ${
                              hoverIndex === index
                                ? "opacity-0 duration-300 delay-0"
                                : "opacity-100  duration-500 delay-300"
                            }`}
                          >
                            {card?.stat_descriptor?.text}
                          </p>
                        )}

                        {card?.card_title?.text && (
                          <p
                            className={`text-white absolute font-manrope bottom-0 text-xl font-semibold sm:text-3.25xl sm:leading-10 tracking-tighter_2 sm:tracking-tightest_7 transition-opacity ease-in-out ${
                              hoverIndex === index
                                ? "opacity-100 duration-500 delay-300"
                                : "opacity-0 duration-300 delay-0"
                            }`}
                          >
                            {card?.card_title?.text}
                          </p>
                        )}
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="bottom-[2px] right-0 absolute sm:hidden"
                        >
                          <path
                            d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                            fill="#ffffff"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}

          {/* Three Grid Layout */}
          {threeGrid &&
            slice?.items?.length === 3 &&
            slice?.items.map((card, index) => {
              if (index === 1) {
                return (
                  <div
                    key="1-2"
                    className="col-span-6 flex flex-col sm:flex-row lg:flex-col gap-4"
                  >
                    {[1, 2].map((i) => {
                      const c = slice.items[i];

                      return (
                        <a
                          href={c.link?.url}
                          target="_blank"
                          className="lg:h-full w-full "
                        >
                          <div
                            key={i}
                            className="rounded-[10px] p-4 sm:p-6 overflow-hidden group w-full relative h-[288px] sm:h-[315px] "
                            style={{
                              backgroundImage: `url(${c?.card_image?.url || ""})`,
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center",
                            }}
                            onMouseEnter={() => setHoverIndex(i)}
                            onMouseLeave={() => setHoverIndex(null)}
                          >
                            {/* Gradient Overlay */}
                            <div
                              className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear `}
                            />
                            {/* Hover gradient (fades in on hover) */}
                            <div
                              className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                                hoverIndex === i
                                  ? "opacity-100 duration-500 delay-0"
                                  : "opacity-0 duration-300 delay-0"
                              }`}
                            />

                            <div className="flex flex-col justify-between h-full  relative z-10">
                              <img
                                className="max-w-28 sm:max-h-full "
                                alt={c?.logo?.alt || "Card_logo"}
                                loading="eager"
                                src={c?.logo?.url}
                              />
                              <div className="relative">
                                <p
                                  className={`text-white font-manrope text-[65px] font-semibold leading-[68px] -tracking-[3px] transition-opacity duration-300 ${
                                    hoverIndex === i
                                      ? "opacity-0 duration-300 delay-0"
                                      : "opacity-100  duration-500 delay-300"
                                  }`}
                                >
                                  {c?.stat_headline?.text}
                                </p>
                                {card?.stat_descriptor?.text && (
                                  <p
                                    className={`text-white font-manrope text-xl font-semibold sm:text-2xl transition-opacity tracking-tighter_2 sm:tracking-tightest_5 ${
                                      hoverIndex === i
                                        ? "opacity-0 duration-300 delay-0"
                                        : "opacity-100  duration-500 delay-300"
                                    }`}
                                  >
                                    {card?.stat_descriptor?.text}
                                  </p>
                                )}

                                {card?.card_title?.text && (
                                  <p
                                    className={` absolute bottom-0 transition-opacity ease-in-out text-white font-manrope text-xl font-semibold sm:text-3.25xl tracking-tighter_2 sm:leading-10 sm:tracking-tightest_7 ${
                                      hoverIndex === i
                                        ? "opacity-100 duration-500 delay-300"
                                        : "opacity-0 duration-300 delay-0"
                                    }`}
                                  >
                                    {card?.card_title?.text}
                                  </p>
                                )}
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="bottom-[2px] right-0 absolute sm:hidden"
                                >
                                  <path
                                    d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                                    fill="#ffffff"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                );
              }

              // Skip rendering index 2 because it's already handled above
              if (index === 2) return null;

              // Render all others normally
              return (
                <a
                  href={card?.link?.url}
                  target="_blank"
                  className={`${index === 0 && "col-span-6"} `}
                >
                  <div
                    key={index}
                    className={`${
                      index === 0 && "col-span-6"
                    } ${twoGrid && "w-full"} rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative`}
                    style={{
                      backgroundImage: `url(${card?.card_image?.url || ""})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                    onMouseEnter={() => setHoverIndex(index)}
                    onMouseLeave={() => setHoverIndex(null)}
                  >
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear `}
                    />
                    {/* Hover gradient (fades in on hover) */}
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                        hoverIndex === index
                          ? "opacity-100 duration-500 delay-0"
                          : "opacity-0 duration-300 delay-0"
                      }`}
                    />

                    <div className="flex flex-col justify-between h-full gap-[145px] sm:gap-[405px] lg:gap-[405px] relative z-10">
                      <img
                        className="max-w-28  sm:max-w-48"
                        alt={card?.logo?.alt || "Card_logo"}
                        loading="eager"
                        src={card?.logo?.url}
                      />
                      <div className="relative">
                        <p
                          className={`text-white font-manrope text-5.5xl sm:text-[90px] font-semibold leading-[68px] sm:leading-[100px] -tracking-[3px] sm:-tracking-[4.5px] transition-opacity duration-300 ${
                            hoverIndex === index
                              ? "opacity-0 duration-300 delay-0"
                              : "opacity-100  duration-500 delay-300"
                          }`}
                        >
                          {card?.stat_headline?.text}
                        </p>
                        {card?.stat_descriptor?.text && (
                          <p
                            className={`text-white font-manrope text-xl font-semibold sm:text-2xl transition-opacity duration-300 tracking-tighter_2 sm:tracking-tightest_5 ${
                              hoverIndex === index
                                ? "opacity-0 duration-300 delay-0"
                                : "opacity-100  duration-500 delay-300"
                            }`}
                          >
                            {card?.stat_descriptor?.text}
                          </p>
                        )}

                        {card?.card_title?.text && (
                          <p
                            className={`text-white absolute font-manrope bottom-0 text-xl font-semibold sm:text-3.25xl tracking-tighter_2 sm:leading-10 sm:tracking-tightest_7 transition-opacity ease-in-out ${
                              hoverIndex === index
                                ? "opacity-100 duration-500 delay-300"
                                : "opacity-0 duration-300 delay-0"
                            }`}
                          >
                            {card?.card_title?.text}
                          </p>
                        )}
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="bottom-[2px] right-0 absolute sm:hidden"
                        >
                          <path
                            d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                            fill="#ffffff"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}

          {/* Four Grid Layout */}
          {fourGrid &&
            slice?.items?.length === 4 &&
            slice?.items.map((card, index) => {
              return (
                <a href={card.link?.url} target="_blank" className="w-full">
                  <div
                    className={`rounded-[10px] p-4 sm:p-6 h-[288px] sm:h-[315px] lg:h-[304px] overflow-hidden group relative w-full`}
                    style={{
                      backgroundImage: `url(${card?.card_image?.url || ""})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      objectFit: "fill",
                      backgroundPosition: "center",
                    }}
                    onMouseEnter={() => setHoverIndex(index)}
                    onMouseLeave={() => setHoverIndex(null)}
                  >
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear`}
                    />
                    {/* Hover gradient (fades in on hover) */}
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                        hoverIndex === index
                          ? "opacity-100 duration-500 delay-0"
                          : "opacity-0 duration-300 delay-0"
                      }`}
                    />
                    <div className="flex flex-col justify-between h-full ">
                      <img
                        className="max-w-28 sm:max-h-full z-10"
                        alt={card?.logo?.alt || "Card_logo"}
                        loading="eager"
                        src={card?.logo?.url}
                      />
                      <div className="z-10 relative">
                        <p
                          className={`text-white font-manrope text-[65px] font-semibold leading-[68px] -tracking-[3px] transition-opacity ${hoverIndex === index ? "opacity-0 duration-300 delay-0" : "opacity-100  duration-500 delay-300"}`}
                        >
                          {card?.stat_headline?.text}
                        </p>

                        {card?.stat_descriptor?.text && (
                          <p
                            className={`text-white font-manrope text-xl font-semibold sm:text-2xl transition-opacity tracking-tighter_2 sm:tracking-tightest_5 ${
                              hoverIndex === index
                                ? "opacity-0 duration-300 delay-0"
                                : "opacity-100  duration-500 delay-300"
                            }`}
                          >
                            {card?.stat_descriptor?.text}
                          </p>
                        )}

                        {card?.card_title?.text && (
                          <p
                            className={` absolute bottom-0 transition-opacity ease-in-out text-white font-manrope text-xl font-semibold sm:text-3.25xl tracking-tighter_2 sm:leading-10 sm:tracking-tightest_7 ${
                              hoverIndex === index
                                ? "opacity-100 duration-300 delay-300"
                                : "opacity-0 duration-300 delay-0"
                            }`}
                          >
                            {card?.card_title?.text}
                          </p>
                        )}
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="bottom-[2px] right-0 absolute sm:hidden"
                        >
                          <path
                            d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                            fill="#ffffff"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}

          {/* Five Grid Layout */}
          {fiveGrid &&
            slice?.items?.length === 5 &&
            slice?.items?.map((card, index) => {
              if (index === 1) {
                return (
                  <div
                    key="1-2"
                    className="col-span-6 grid grid-cols-1 sm:grid-cols-2 gap-4"
                  >
                    {Array.from({ length: 4 }, (_, i) => {
                      const c = slice.items[i + 1]; // index 1,2,3,4
                      return (
                        <a
                          href={c?.link?.url}
                          target="_blank"
                          className=" lg:h-full w-full"
                        >
                          <div
                            key={i}
                            className="rounded-[10px] p-4 sm:p-6 overflow-hidden group w-full relative h-[288px] sm:h-[315px] lg:min-h-[304px] lg:h-full"
                            style={{
                              backgroundImage: `url(${c?.card_image?.url || ""})`,
                              backgroundSize: "cover",
                              backgroundRepeat: "no-repeat",
                              backgroundPosition: "center",
                            }}
                            onMouseEnter={() => setHoverIndex(i + 1)}
                            onMouseLeave={() => setHoverIndex(null)}
                          >
                            {/* Gradient Overlay */}
                            <div
                              className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear`}
                            />
                            {/* Hover gradient (fades in on hover) */}
                            <div
                              className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                                hoverIndex === i + 1
                                  ? "opacity-100 duration-500 delay-0"
                                  : "opacity-0 duration-300 delay-0"
                              }`}
                            />
                            <div className="flex flex-col justify-between h-full relative z-10">
                              <img
                                className="max-w-28 sm:max-h-full"
                                alt={c?.logo?.alt || "Card_logo"}
                                loading="eager"
                                src={c?.logo?.url}
                              />
                              <div className="relative">
                                <p
                                  className={`text-white font-manrope text-[65px] font-semibold leading-[68px]  -tracking-[3px] transition-opacity ${
                                    hoverIndex === i + 1
                                      ? "opacity-0 duration-300 delay-0"
                                      : "opacity-100  duration-500 delay-300"
                                  }`}
                                >
                                  {c?.stat_headline?.text}
                                </p>

                                {c?.stat_descriptor?.text && (
                                  <p
                                    className={`text-white font-manrope text-xl font-semibold sm:text-xl transition-opacity tracking-tighter_2 sm:tracking-tightest ${
                                      hoverIndex === i + 1
                                        ? "opacity-0 duration-300 delay-0"
                                        : "opacity-100  duration-500 delay-300"
                                    }`}
                                  >
                                    {c?.stat_descriptor?.text}
                                  </p>
                                )}

                                {c?.card_title?.text && (
                                  <p
                                    className={` absolute bottom-0 transition-opacity ease-in-out text-white font-manrope text-xl font-semibold sm:text-2xl tracking-tighter_2 sm:tracking-tightest_5 ${
                                      hoverIndex === i + 1
                                        ? "opacity-100 duration-500 delay-300"
                                        : "opacity-0 duration-300 delay-0"
                                    }`}
                                  >
                                    {c?.card_title?.text}
                                  </p>
                                )}
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 18 18"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="bottom-[2px] right-0 absolute sm:hidden"
                                >
                                  <path
                                    d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                                    fill="#ffffff"
                                  />
                                </svg>
                              </div>
                            </div>
                          </div>
                        </a>
                      );
                    })}
                  </div>
                );
              }

              // Skip rendering for indexes 2, 3, 4
              if (index >= 2 && index <= 4) {
                return null;
              }

              // Render others normally
              return (
                <a
                  href={card?.link?.url}
                  target="_blank"
                  className={`${index === 0 && "col-span-6"}  h-full`}
                >
                  <div
                    key={index}
                    className={`${
                      index === 0 && "col-span-6"
                    } ${twoGrid && "w-full"} rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative`}
                    style={{
                      backgroundImage: `url(${card?.card_image?.url || ""})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                    }}
                    onMouseEnter={() => setHoverIndex(index)}
                    onMouseLeave={() => setHoverIndex(null)}
                  >
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear `}
                    />
                    {/* Hover gradient (fades in on hover) */}
                    <div
                      className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                        hoverIndex === index
                          ? "opacity-100 duration-500 delay-0"
                          : "opacity-0 duration-300 delay-0"
                      }`}
                    />
                    <div className="flex flex-col justify-between h-full gap-[145px] sm:gap-[405px] lg:gap-[405px] relative z-10">
                      <img
                        className="max-w-28 sm:max-w-[153px]"
                        alt={card?.logo?.alt || "Card_logo"}
                        loading="eager"
                        src={card?.logo?.url}
                      />
                      <div>
                        <p
                          className={`text-white font-manrope text-5.5xl sm:text-[90px] font-semibold leading-[68px] sm:leading-[100px] -tracking-[3px] sm:-tracking-[4.5px] transition-opacity ${
                            hoverIndex === index
                              ? "opacity-0 duration-300 delay-0"
                              : "opacity-100  duration-500 delay-300"
                          }`}
                        >
                          {card?.stat_headline?.text}
                        </p>

                        {card?.stat_descriptor?.text && (
                          <p
                            className={`text-white font-manrope text-xl font-semibold sm:text-2xl transition-opacity tracking-tighter_2 sm:tracking-tightest_5 ${
                              hoverIndex === index
                                ? "opacity-0 duration-300 delay-0"
                                : "opacity-100  duration-500 delay-300"
                            }`}
                          >
                            {card?.stat_descriptor?.text}
                          </p>
                        )}

                        {card?.card_title?.text && (
                          <p
                            className={`text-white absolute font-manrope bottom-0 text-xl font-semibold sm:text-3.25xl tracking-tighter_2 sm:leading-10 sm:tracking-tightest_7 transition-opacity ease-in-out ${
                              hoverIndex === index
                                ? "opacity-100 duration-500 delay-300"
                                : "opacity-0 duration-300 delay-0"
                            }`}
                          >
                            {card?.card_title?.text}
                          </p>
                        )}
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="bottom-[2px] right-0 absolute sm:hidden"
                        >
                          <path
                            d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                            fill="#ffffff"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}

          {/* Five Plus Grid Layout Desktop */}
          {fivePlusGrid && slice?.items?.length > 5 && isDesktop && (
            <>
              {/* 1st big card */}
              <div className="col-span-6 row-span-2">
                {slice.items[0] && (
                  <a href={slice.items[0]?.link?.url} target="_blank">
                    <div
                      className="rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative"
                      style={{
                        backgroundImage: `url(${slice.items[0]?.card_image?.url || ""})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                      }}
                      onMouseEnter={() => setHoverIndex(0)}
                      onMouseLeave={() => setHoverIndex(null)}
                    >
                      {/* Gradient Overlay */}
                      <div
                        className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear`}
                      />
                      {/* Hover gradient (fades in on hover) */}
                      <div
                        className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                          hoverIndex === 0
                            ? "opacity-100 duration-500 delay-0"
                            : "opacity-0 duration-300 delay-0"
                        }`}
                      />
                      <div className="flex flex-col justify-between h-full gap-[145px] sm:gap-[405px] lg:gap-[405px] relative z-10">
                        <img
                          className="max-w-28 sm:max-w-48"
                          alt={slice.items[0]?.logo?.alt || "Card_logo"}
                          loading="eager"
                          src={slice.items[0]?.logo?.url}
                        />
                        <div>
                          <p
                            className={`text-white font-manrope text-5.5xl sm:text-[90px] font-semibold leading-[68px] sm:leading-[100px] -tracking-[3px] sm:-tracking-[4.5px] transition-opacity ${
                              hoverIndex === 0
                                ? "opacity-0 duration-300 delay-0"
                                : "opacity-100  duration-500 delay-300"
                            }`}
                          >
                            {slice.items[0]?.stat_headline?.text}
                          </p>
                          {slice.items[0]?.stat_descriptor?.text && (
                            <p
                              className={`text-white font-manrope text-sm font-semibold sm:text-2xl transition-opacity tracking-tighter_2 sm:tracking-tightest_5 ${
                                hoverIndex === 0
                                  ? "opacity-0 duration-300 delay-0"
                                  : "opacity-100  duration-500 delay-300"
                              }`}
                            >
                              {slice.items[0]?.stat_descriptor?.text}
                            </p>
                          )}

                          {slice.items[0]?.card_title?.text && (
                            <p
                              className={`text-white absolute font-manrope bottom-0 text-sm font-semibold sm:text-3.25xl tracking-tighter_2 sm:leading-10 sm:tracking-tightest_7 transition-opacity ease-in-out ${
                                hoverIndex === 0
                                  ? "opacity-100 duration-500 delay-300"
                                  : "opacity-0 duration-300 delay-0"
                              }`}
                            >
                              {slice.items[0]?.card_title?.text}
                            </p>
                          )}
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="bottom-[2px] right-0 absolute sm:hidden"
                          >
                            <path
                              d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                  </a>
                )}
              </div>

              {/* Cards 2, 3, 4, 5 */}
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className={`col-span-3 ${
                    i === 1 ? "col-start-7" : ""
                  } ${i === 2 ? "col-start-10" : ""} ${
                    i === 3 ? "col-start-7 row-start-2" : ""
                  } ${i === 4 ? "col-start-10 row-start-2" : ""}`}
                >
                  {slice.items[i] && (
                    <a href={slice.items[i]?.link?.url} target="_blank">
                      <div
                        className="rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative"
                        style={{
                          backgroundImage: `url(${slice.items[i]?.card_image?.url || ""})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                        onMouseEnter={() => setHoverIndex(i)}
                        onMouseLeave={() => setHoverIndex(null)}
                      >
                        {/* Gradient Overlay */}
                        <div
                          className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear `}
                        />
                        {/* Hover gradient (fades in on hover) */}
                        <div
                          className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                            hoverIndex === i
                              ? "opacity-100 duration-500 delay-0"
                              : "opacity-0 duration-300 delay-0"
                          }`}
                        />
                        <div className="flex flex-col justify-between h-full relative z-10">
                          <img
                            className="max-w-28"
                            alt={slice.items[i]?.logo?.alt || "Card_logo"}
                            loading="eager"
                            src={slice.items[i]?.logo?.url}
                          />
                          <div>
                            <p
                              className={`text-white font-manrope text-[65px] font-semibold leading-[68px] transition-opacity ${
                                hoverIndex === i
                                  ? "opacity-0 duration-300 delay-0"
                                  : "opacity-100  duration-500 delay-300"
                              }`}
                            >
                              {slice.items[i]?.stat_headline?.text}
                            </p>

                            {slice.items[i]?.stat_descriptor?.text && (
                              <p
                                className={`text-white font-manrope text-sm font-semibold sm:text-xl transition-opacity tracking-tighter_2 sm:tracking-tightest ${
                                  hoverIndex === i
                                    ? "opacity-0 duration-300 delay-0"
                                    : "opacity-100  duration-500 delay-300"
                                }`}
                              >
                                {slice.items[i]?.stat_descriptor?.text}
                              </p>
                            )}

                            {slice.items[i]?.card_title?.text && (
                              <p
                                className={` absolute bottom-0 transition-opacity ease-in-out text-white font-manrope text-sm font-semibold sm:text-2xl tracking-tighter_2 sm:tracking-tightest_5 ${
                                  hoverIndex === i
                                    ? "opacity-100 duration-500 delay-300"
                                    : "opacity-0 duration-300 delay-0"
                                }`}
                              >
                                {slice.items[i]?.card_title?.text}
                              </p>
                            )}
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="bottom-[2px] right-0 absolute sm:hidden"
                            >
                              <path
                                d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                                fill="#ffffff"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </a>
                  )}
                </div>
              ))}

              {/* Cards 6, 7, 8 */}
              {[5, 6, 7].map((i, idx) => (
                <div
                  key={i}
                  className={`col-span-4 row-start-3 ${
                    idx === 1 ? "col-start-5" : idx === 2 ? "col-start-9" : ""
                  }`}
                >
                  {slice.items[i] && (
                    <a href={slice.items[i]?.link?.url} target="_blank">
                      <div
                        className="rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative"
                        style={{
                          backgroundImage: `url(${slice.items[i]?.card_image?.url || ""})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                        onMouseEnter={() => setHoverIndex(i)}
                        onMouseLeave={() => setHoverIndex(null)}
                      >
                        {/* Gradient Overlay */}
                        <div
                          className={`absolute inset-0 z-0 rounded-[10px] un_hover_gradient transition-opacity ease-linear`}
                        />
                        {/* Hover gradient (fades in on hover) */}
                        <div
                          className={`absolute inset-0 z-0 rounded-[10px] hover_gradient transition-opacity ease-linear ${
                            hoverIndex === i
                              ? "opacity-100 duration-500 delay-0"
                              : "opacity-0 duration-300 delay-0"
                          }`}
                        />
                        <div className="flex flex-col justify-between h-full relative z-10">
                          <img
                            className="max-w-28"
                            alt={slice.items[i]?.logo?.alt || "Card_logo"}
                            loading="eager"
                            src={slice.items[i]?.logo?.url}
                          />
                          <div>
                            <p
                              className={`text-white font-manrope text-[65px] font-semibold leading-[68px] transition-opacity ${
                                hoverIndex === i
                                  ? "opacity-0 duration-300 delay-0"
                                  : "opacity-100 duration-500 delay-300"
                              }`}
                            >
                              {slice.items[i]?.stat_headline?.text}
                            </p>
                            {slice.items[i]?.stat_descriptor?.text && (
                              <p
                                className={`text-white font-manrope text-sm font-semibold sm:text-xl transition-opacity tracking-tighter_2 sm:tracking-tightest ${
                                  hoverIndex === i
                                    ? "opacity-0 duration-300 delay-0"
                                    : "opacity-100 duration-500 delay-300"
                                }`}
                              >
                                {slice.items[i]?.stat_descriptor?.text}
                              </p>
                            )}

                            {slice.items[i]?.card_title?.text && (
                              <p
                                className={` absolute bottom-0 transition-opacity ease-in-out text-white font-manrope text-sm font-semibold sm:text-2xl tracking-tighter_2 sm:tracking-tightest_5 ${
                                  hoverIndex === i
                                    ? "opacity-100 duration-500 delay-300"
                                    : "opacity-0 duration-300 delay-0"
                                }`}
                              >
                                {slice.items[i]?.card_title?.text}
                              </p>
                            )}
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="bottom-[2px] right-0 absolute sm:hidden"
                            >
                              <path
                                d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                                fill="#ffffff"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </a>
                  )}
                </div>
              ))}
            </>
          )}

          {/* Five Plus Grid Layout Tablet */}
          {fivePlusGrid && slice?.items?.length > 5 && isTablet && (
            <>
              {/* 1st big card */}
              <div className="col-span-2 md:col-span-6 md:row-span-2">
                {slice.items[0] && (
                  <a href={slice.items[0]?.link?.url} target="_blank">
                    <div
                      className="rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative"
                      style={{
                        backgroundImage: `url(${slice.items[0]?.card_image?.url || ""})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                      }}
                      onMouseEnter={() => setHoverIndex(0)}
                      onMouseLeave={() => setHoverIndex(null)}
                    >
                      {/* Gradient Overlay */}
                      <div
                        className={`absolute rounded-[10px] z-0 inset-0 pointer-events-none transition-opacity duration-300 ${
                          hoverIndex === 0
                            ? "hover_gradient"
                            : "un_hover_gradient"
                        }`}
                      />
                      <div className="flex flex-col justify-between h-full gap-[145px] sm:gap-[405px] lg:gap-[405px] relative z-10">
                        <img
                          className="max-w-28 sm:max-w-48"
                          alt={slice.items[0]?.logo?.alt || "Card_logo"}
                          loading="eager"
                          src={slice.items[0]?.logo?.url}
                        />
                        <div>
                          <p
                            className={`text-white font-manrope text-5.5xl sm:text-[90px] font-semibold leading-[68px] sm:leading-[100px] -tracking-[3px] sm:-tracking-[4.5px] transition-opacity duration-300 ${
                              hoverIndex === 0 ? "opacity-0" : "opacity-100"
                            }`}
                          >
                            {slice.items[0]?.stat_headline?.text}
                          </p>
                          <p className="text-white font-manrope text-sm font-semibold sm:text-xl transition-colors duration-300 tracking-tighter_2 sm:tracking-tightest">
                            {hoverIndex === 0
                              ? slice.items[0]?.card_title?.text
                              : slice.items[0]?.stat_descriptor?.text}
                          </p>
                        </div>
                      </div>
                    </div>
                  </a>
                )}
              </div>

              {/* Cards 2, 3, 4, 5 */}
              {[1, 2, 3, 4].map((i, idx) => (
                <div
                  key={i}
                  className={`${
                    i <= 2 ? " row-start-2" : i === 4 ? "row-start-3" : ""
                  } ${i === 2 ? "" : ""} ${
                    idx === 0 ? "md:col-start-7" : ""
                  } ${idx === 1 ? "md:col-start-10" : ""} ${idx === 2 ? "md:col-start-7 md:row-start-2" : ""} ${idx === 3 ? "md:col-start-10 md:row-start-2" : ""} col-span-1`}
                >
                  {slice.items[i] && (
                    <a href={slice.items[i]?.link?.url} target="_blank">
                      <div
                        className="rounded-[10px] p-4 sm:p-6 h-[315px] overflow-hidden group relative"
                        style={{
                          backgroundImage: `url(${slice.items[i]?.card_image?.url || ""})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                        onMouseEnter={() => setHoverIndex(i)}
                        onMouseLeave={() => setHoverIndex(null)}
                      >
                        {/* Gradient Overlay */}
                        <div
                          className={`absolute rounded-[10px] z-0 inset-0 pointer-events-none transition-opacity duration-300 ${
                            hoverIndex === i
                              ? "hover_gradient"
                              : "un_hover_gradient"
                          }`}
                        />
                        <div className="flex flex-col justify-between h-full relative z-10">
                          <img
                            className="max-w-28"
                            alt={slice.items[i]?.logo?.alt || "Card_logo"}
                            loading="eager"
                            src={slice.items[i]?.logo?.url}
                          />
                          <div>
                            <p
                              className={`text-white font-manrope text-[65px] font-semibold leading-[68px] transition-opacity duration-300 ${
                                hoverIndex === i ? "opacity-0" : "opacity-100"
                              }`}
                            >
                              {slice.items[i]?.stat_headline?.text}
                            </p>
                            <p className="text-white font-manrope text-sm font-semibold transition-colors duration-300 tracking-tighter_2">
                              {hoverIndex === i
                                ? slice.items[i]?.card_title?.text
                                : slice.items[i]?.stat_descriptor?.text}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                  )}
                </div>
              ))}

              {/* Cards 6, 7, 8 */}
              {[5, 6, 7].map((i, idx) => (
                <div
                  key={i}
                  className={`${idx === 0 ? "" : ""} h-[315px] ${
                    idx === 1 ? "row-start-4" : ""
                  } ${idx === 2 ? "col-span-2 row-start-5" : "col-span-1"} ${
                    idx === 0
                      ? "md:col-span-4 md:row-start-3 "
                      : idx === 1
                        ? "md:col-span-4 md:col-start-5 md:row-start-3"
                        : idx === 2
                          ? "md:col-span-4 md:col-start-9 md:row-start-3 "
                          : ""
                  }`}
                >
                  {slice.items[i] && (
                    <a href={slice.items[i]?.link?.url} target="_blank">
                      <div
                        className="rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative"
                        style={{
                          backgroundImage: `url(${slice.items[i]?.card_image?.url || ""})`,
                          backgroundSize: "cover",
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "center",
                        }}
                        onMouseEnter={() => setHoverIndex(i)}
                        onMouseLeave={() => setHoverIndex(null)}
                      >
                        {/* Gradient Overlay */}
                        <div
                          className={`absolute rounded-[10px] z-0 inset-0 pointer-events-none transition-opacity duration-300 ${
                            hoverIndex === i
                              ? "hover_gradient"
                              : "un_hover_gradient"
                          }`}
                        />
                        <div className="flex flex-col justify-between h-full relative z-10">
                          <img
                            className="max-w-28"
                            alt={slice.items[i]?.logo?.alt || "Card_logo"}
                            loading="eager"
                            src={slice.items[i]?.logo?.url}
                          />
                          <div>
                            <p
                              className={`text-white font-manrope text-[65px] font-semibold leading-[68px] transition-opacity duration-300 ${
                                hoverIndex === i ? "opacity-0" : "opacity-100"
                              }`}
                            >
                              {slice.items[i]?.stat_headline?.text}
                            </p>
                            <p className="text-white font-manrope text-sm font-semibold transition-colors duration-300 tracking-tighter_2">
                              {hoverIndex === i
                                ? slice.items[i]?.card_title?.text
                                : slice.items[i]?.stat_descriptor?.text}
                            </p>
                          </div>
                        </div>
                      </div>
                    </a>
                  )}
                </div>
              ))}
            </>
          )}

          {/* Five Plus Grid Layout Mobile */}
          {fivePlusGrid &&
            slice?.items?.length > 5 &&
            isMobile &&
            slice?.items.map((card, index) => {
              return (
                <a href={card?.link?.url} target="_blank">
                  <div
                    className={`rounded-[10px] p-4 sm:p-6 h-full overflow-hidden group relative ${twoGrid && "w-full"}`}
                    style={{
                      backgroundImage: `url(${card?.card_image?.url || ""})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      objectFit: "fill",
                      backgroundPosition: "center",
                    }}
                    onMouseEnter={() => setHoverIndex(index)}
                    onMouseLeave={() => setHoverIndex(null)}
                  >
                    <div
                      className={`absolute rounded-[10px] z-0 inset-0  ${hoverIndex === index ? "hover_gradient" : "un_hover_gradient"} opacity-100 transition-opacity duration-300 pointer-events-none`}
                    />
                    <div className="flex flex-col justify-between h-full gap-[145px] sm:gap-[405px] lg:gap-[411px] ">
                      <img
                        className="max-w-28 sm:h-full sm:max-h-full sm:max-w-48 z-10"
                        alt={card?.logo?.alt || "Card_logo"}
                        loading="eager"
                        src={card?.logo?.url}
                      />
                      <div className="z-10">
                        <p
                          className={`text-white font-manrope text-5.5xl sm:text-[90px] font-semibold leading-[68px] sm:leading-[100px] -tracking-[3px] sm:-tracking-[4.5px] transition-opacity duration-300 ${hoverIndex === index && "opacity-0"}`}
                        >
                          {card?.stat_headline?.text}
                        </p>
                        <p className="text-white font-manrope text-xl font-semibold sm:text-xl transition-colors duration-300 tracking-tighter_2 sm:tracking-tightest ">
                          {hoverIndex === index
                            ? card?.card_title?.text
                            : card?.stat_descriptor?.text}
                        </p>
                        <svg
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-auto transition-transform duration-300 ease-in-out group-hover:translate-x-2.5 sm:hidden"
                        >
                          <path
                            d="M1.25165 10.0968L13.0355 10.0968L5.98253 16.0743C5.86974 16.1707 5.93822 16.3496 6.08725 16.3496L7.86964 16.3496C7.94818 16.3496 8.0227 16.3221 8.08111 16.2729L15.692 9.82545C15.7617 9.76646 15.8176 9.69353 15.8559 9.6116C15.8942 9.52967 15.9141 9.44066 15.9141 9.35059C15.9141 9.26053 15.8942 9.17151 15.8559 9.08959C15.8176 9.00766 15.7617 8.93473 15.692 8.87573L8.0368 2.38893C8.00659 2.36337 7.97034 2.34961 7.93207 2.34961L6.08927 2.34961C5.94023 2.34961 5.87176 2.53051 5.98454 2.62489L13.0355 8.60242L1.25165 8.60242C1.16304 8.60242 1.09053 8.67321 1.09053 8.75972L1.09053 9.9395C1.09053 10.026 1.16304 10.0968 1.25165 10.0968Z"
                            fill="#ffffff"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })}
        </div>
      </article>
    </section>
  );
};

export default FeatureLewitt;
